module.exports = __webpack_public_path__ + "static/media/banner.7e07dc7a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner.png
// module id = 1022
// module chunks = 0